<script>

    export let match;   

</script>
<div class='list-group list-group-flush'>
    <div class='list-group-item'>

        {#if match.team_a == null}

            <div class='row'>
                <div class='col-2'>
                    
                </div>
                <div class='col-8 text-center'>
                    <h4 class='m-0 text-secondary'>
                        <span class='fas fa-info-circle'></span> EMPTY
                    </h4>
                </div>
                <div class='col-2 text-end'>
                    
                   
                </div>
            </div>                

        {:else}

            <div class='row'>
                <div class='col-2'>

                    {#if match.team_a.logo}

                        <img src={match.team_a.logo} class='img-responsive img-thumbnail' alt='Team Logo'/>

                    {/if}

                </div>
                <div class='col-8 text-center'>
                    <div class=''>                        
                        <h4 class='mb-1 text-primary'>

                            { match.team_a.name }
        
                        </h4>                                                
                        
                    </div>
                </div>
                <div class='col-2 text-end'>                    
                   
                </div>
            </div>            

        {/if}

    </div>
    <div class='list-group-item'>
        <div class='text-center'>
            <h5 class='m-0'>
                VS
            </h5>
        </div>
    </div>
    <div class='list-group-item'>
        
        {#if match.team_b == null}

            <div class='row'>
                <div class='col-2'>
                    
                </div>
                <div class='col-8 text-center'>
                    <h4 class='m-0 text-secondary'>
                        <span class='fas fa-info-circle'></span> EMPTY
                    </h4>
                </div>
                <div class='col-2 text-end'>
                                       

                </div>
            </div> 

        {:else}

            <div class='row'>
                <div class='col-2'>

                    {#if match.team_b.logo}

                        <img src={match.team_b.logo} class='img-responsive img-thumbnail' alt='Team Logo'/>

                    {/if}

                </div>
                <div class='col-8 text-center'>
                    <h4 class='mb-1 text-primary'>

                        { match.team_b.name }
    
                    </h4>                   

                </div>
                <div class='col-2 text-end'>
                    
                </div>
            </div>

        {/if}

    </div>
</div>